var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTutorFeedback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5831_807)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.73478 9.91344C1.83478 9.32678 1.94811 8.62011 2.08145 7.92678C2.14811 7.58011 2.06145 7.32011 1.80145 7.08011C1.35478 6.67344 0.934779 6.24678 0.501446 5.82678C0.0547794 5.39344 -0.111887 4.88011 0.0814461 4.28678C0.274779 3.70011 0.701446 3.36678 1.31478 3.28011C1.92145 3.19344 2.52145 3.09344 3.13478 3.01344C3.48145 2.97344 3.70811 2.82011 3.85478 2.49344C4.10811 1.93344 4.39478 1.39344 4.66811 0.846775C4.94145 0.300109 5.38811 0.00677542 5.98811 0.000108756C6.60811 -0.00655791 7.06145 0.293442 7.33478 0.853442C7.60811 1.40011 7.89478 1.94011 8.14811 2.50011C8.29478 2.82678 8.52811 2.97344 8.87478 3.01344C9.50145 3.09344 10.1281 3.19344 10.7481 3.29344C11.3348 3.38011 11.7281 3.71344 11.9148 4.26678C12.1081 4.83344 11.9748 5.34678 11.5548 5.76678C11.1014 6.22011 10.6414 6.67344 10.1748 7.10678C9.92811 7.33344 9.85478 7.58011 9.91478 7.90678C10.0348 8.54011 10.1548 9.16678 10.2414 9.80011C10.3614 10.6401 9.84811 11.3534 9.00811 11.4534C8.70811 11.4934 8.35478 11.4068 8.06811 11.2801C7.50145 11.0334 6.95478 10.7201 6.40811 10.4201C6.12145 10.2601 5.86145 10.2668 5.56811 10.4201C4.98811 10.7401 4.40811 11.0601 3.80811 11.3334C2.83478 11.8001 1.73478 11.0934 1.73478 9.91344Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5831_807"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 11.48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTutorFeedback);
export default __webpack_public_path__ + "static/media/TutorFeedback.5ae4da533f4517d55e69680befe7c9ec.svg";
export { ForwardRef as ReactComponent };